<bootstrap-popup
	[id]="'editIntervenantDialog'"
	[title]="title"
	[modalSize]="'modal-lg'"
	[windowCloseButton]="true"
	[displaySubject]="popupVisibility$"
	>
	<form *ngIf="intervenant" role="form" class="form-horizontal" >
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label">Nom&nbsp;*:</label>
			<div class="col-sm-9">
				<suggestable-input
					[inputClass]="'form-control'"
					[suggestionsObservableGetter]="observablePourSuggestionNom"
					[placeholder]="'Entrer le nom de l\'intervenant'"
					[categoryBuilders]="suggestionCategoryBuilders"
					[labelGetter]="getSuggestionsLabel"
					[labelAsHtml]="true"
					[inputLabelGetter]="getSuggestionsLabelForInput"
					[(value)]= "intervenant.nom"
					(valueChange)= "intervenant.nom = $event"
					(valueSelected)= "onSuggestionNomSelected($event)"
					>
				</suggestable-input>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="cafirstname">Pr&eacute;nom&nbsp;*:</label>
			<div class="col-sm-9">
				<input type="text"
					id="cafirstname" name="cafirstname"
					class="efirstname form-control"
					placeholder="Entrer le pr&eacute;nom de l'intervenant"
					maxlength="100"
					[(ngModel)]="intervenant.prenom"
					/>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="catelephone">T&eacute;l&eacute;phone :</label>
			<div class="col-sm-3">
				<filterable-select
					[inputClass]="'form-control'" 
					[list]="indicatifTelephoneOptions"
					[labelGetter]="getIndicatifLabel" 
					[selectedItem]="indicatifTelephone$ | async"
					(selectedItemChange)="indicatifTelephone$.next($event)"
					>
				</filterable-select>
			</div>
			<div class="col-sm-6">
				<input type="number"
					id="catelephone" name="catelephone"
					class="etelephone form-control"
					title="Saisir le numéro de téléphone sans indicatif pays ni 0. Par exemple, pour un numéro français, ne pas inscrire le début commençant par 0 ou +33 et choisir l'indicatif pays dans la liste déroulante."
					placeholder="Entrer le t&eacute;l&eacute;phone de l'intervenant"
					min="0"
					maxlength="15"
					[ngModel]="telephone$ | async"
					(ngModelChange)="telephone$.next($event)"
				/>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="caemail">E-Mail :</label>
			<div class="col-sm-9">
				<input type="email"
					id="caemail" name="caemail"
					class="eemail form-control"
					placeholder="Entrer l'adresse e-mail de l'intervenant"
					[(ngModel)]="intervenant.email"
					maxlength="255"
				/>
			</div>
		</div>

		<div class="form-group col-sm-12" *ngIf="obsoleteCurrentEntreprise">
			<label class="col-sm-3 control-label" for="caidgmao">Entreprise :</label>
			<div class="col-sm-9">
				<input
					id="currententreprise" name="currententreprise"
					class="form-control"
					[ngModel]="obsoleteCurrentEntreprise.nom"
					disabled
					/>
			</div>
		</div>
		   
		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="caentreprise">{{ obsoleteCurrentEntreprise ? 'Nouvelle entreprise ' : 'Entreprise *' }}:</label>
			<div class="col-sm-9">
				<filterable-select
					[id]="'caentreprise'"
					[inputClass]="'form-control'"
					[list]="availableEntreprises"
					[labelGetter]="getEntrepriseNom"
					[selectedItem] = "entreprise$ | async"
					(selectedItemChange) = "entreprise$.next($event)"
					>
				</filterable-select>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="cacadreemploi">Cadre Emploi :</label>
			<div class="col-sm-9">
				<input type="text"
					id="cacadreemploi" name="cacadreemploi"
					class="ecadreemploi form-control"
					placeholder="Veuillez saisir le cadre emploi"
					maxlength="45"
					[(ngModel)]="intervenant.cadreEmploi"
					/>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<div class="col-sm-3 control-label popover__wrapper" style="margin-top: 0">
				<label for="cainterne">Interne / Externe&nbsp;*:</label>
				<div class="popover__content fix-left-70">
					<div class="panel panel-default modal-sm">
						<div class="panel-heading" role="document">
							<h3>Interne / Externe</h3>
						</div>
						<div class="panel-body">
							On d&eacute;signe par interne, tout intervenant faisant partie d'Engie Green, prestataires inclus. On d&eacute;signe par externe, toute personne non employ&eacute;e par Engie Green
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-9">
				<label class="radio-inline popover__wrapper">
					<input type="radio"
						id="isInterne_oui" name="isInterne"
						[value]="true"
						[(ngModel)]="intervenant.interne"
						>
					Interne
					<div class="popover__content">
						<div class="panel panel-default modal-sm">
							<div class="panel-heading" role="document">
								<h3>Interne</h3>
							</div>
							<div class="panel-body">
								On d&eacute;signe par interne, tout intervenant faisant partie d'Engie Green, prestataires inclus.
							</div>
						</div>
					</div>
				</label>
				<label class="radio-inline popover__wrapper">
					<input type="radio"
						id="isInterne_non" name="isInterne"
						[value]="false"
						[(ngModel)]="intervenant.interne"
						>
					Externe
					<div class="popover__content">
						<div class="panel panel-default modal-sm">
							<div class="panel-heading" role="document">
								<h3>Externe</h3>
							</div>
							<div class="panel-body">
								On d&eacute;signe par externe, toute personne non employ&eacute;e par Engie Green.
							</div>
						</div>
					</div>
				</label>
				<div  *ngIf="intervenant.interne" style="color: red; display: inline-block; vertical-align: bottom; padding-left: 1em;">
					Veuillez saisir le mail au format GAIA&#64;engie.com
				</div>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="cainterne">Responsable Entreprise :</label>
			<div class="col-sm-9">
				<label class="radio-inline" >
					<input type="radio" 
						id="isResponsable_oui" name="isResponsable"
						[value]="true"
						[(ngModel)]="intervenant.estResponsable"
						>
					Oui 
				</label>
				<label class="radio-inline">
					<input type="radio"
						id="isResponsable_non" name="isResponsable"
						[value]="false" 
						[(ngModel)]="intervenant.estResponsable"
						>
					Non 
				</label>
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="caobsolete">Actif&nbsp;*:</label>
			<div class="col-sm-9">
				<label class="radio-inline">
					<input type="radio"
						id="isObsolete_non" name="isObsolete"
						[value]="false"
						[(ngModel)]="intervenant.obsolete"
						>
					Oui
				</label>
				<label class="radio-inline">
					 <input type="radio"
						id="isObsolete_oui" name="isObsolete"
						[value]="true"
						[(ngModel)]="intervenant.obsolete"
						>
					Non
				</label> 
			</div>
		</div>

		<div class="form-group col-sm-12">
			<label class="col-sm-3 control-label" for="isTravailleurDetache_non">Travailleur détaché&nbsp;*:</label>
			<div class="col-sm-9">
				<label class="radio-inline">
					<input type="radio"
						id="isTravailleurDetache_non" name="isTravailleurDetache"
						[value]="true"
						[(ngModel)]="intervenant.travailleurDetache"
						>
					Oui
				</label>
				<label class="radio-inline">
					<input type="radio"
						id="isTravailleurDetache_oui" name="isTravailleurDetache"
						[value]="false"
						[(ngModel)]="intervenant.travailleurDetache"
						>
					Non
				</label> 
			</div>
		</div>

		<div class="form-group text-center">
			<button type="submit"
				class="btn btn-success"
				[disabled]="waitingForServer"
				(click)="save()"
				>
				{{ mode === modes.CREATION ? 'Ajouter' : 'Modifier' }}
			</button>
		</div>
	</form>

	<div ui-view="messageZone"></div>
</bootstrap-popup>